import React from 'react';

import Header from './components/Header';
import Banner from './components/Banner';
import AboutUs from './components/AboutUs';
import OurServices from './components/OurServices';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Header />
      <Banner />
      <main>
        <AboutUs />
        <OurServices />
        <ContactUs />
      </main>
      <Footer />
    </div>
  );
}

export default App;
